import React from 'react';
import { CustomModal, DataList } from 'commons-ui';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';
import useService from '../../../useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { RefundRequestListConfig, DEFAULT_CONFIG } from './listConfig';

const RefundRequestList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getRefundRequests } = useService();
	return (
		<div>
			<CustomModal />
			<DataList
				fetchData={getRefundRequests}
				columnConfigs={RefundRequestListConfig()}
				getActionHandler={getActionHandler}
				actions={actions}
				defaults={DEFAULT_CONFIG}
				disablePagination={false}
				disablePaginationSelect={false}
				entity={LIST_ENTITY_NAMES.DOWNTIME_REFUNDS}
				initialSortDirection='DESC'
				initialSortIndex={1}
				disableColumnFilter
				filterable={false}
				searchable={false}
			/>
		</div>
	);
};

export default RefundRequestList;
